import React from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// @material-ui/icons

// core components
import Header from "components/Header/Header.js";
import HeaderLinks from "components/Header/HeaderLinks.js";
import Footer from "components/Footer/Footer.js";

import styles from "assets/jss/material-kit-react/views/loginPage.js";

import image from "assets/img/Images/bite-cover.jpg";

import YoutubeEmbed from "./YoutubeEmbed";

const useStyles = makeStyles(styles);

export default function BiteInsurance(props) {
    // const [cardAnimaton, setCardAnimation] = React.useState("cardHidden");
    // setTimeout(function () {
    //     setCardAnimation("");
    // }, 700);
    const classes = useStyles();
    const { ...rest } = props;
    return (
        <div>
            <Header
                absolute
                color="transparent"
                brand="Rachit Mehrotra.io"
                rightLinks={<HeaderLinks />}
                {...rest}
            />
            <div
                className={classes.pageHeader}
                style={{
                    backgroundImage: "url(" + image + ")",
                    backgroundSize: "cover",
                    backgroundPosition: "top center",
                }}
            >
                <div className={classes.container}>
                    <YoutubeEmbed embedId="gUKLBZBl_bs" />
                    <h3>Bite Insurance Demo Video</h3>
                </div>


                <Footer whiteFont />
            </div>
        </div>
    );
}
